import React from "react";
import  { useState, useEffect } from 'react';
import './classes/ContactUs.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';

const ContactUs = () => {

    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const domainName = window.location.hostname;

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    return (
        <div id="scout-contactus-main-id">
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main" className="scout-contact-main">
                    <Helmet><title>Contact Us | Sports Management Worldwide</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="scout-contact-container">
                            <h1>Contact Us</h1>
                            <div className="left-content">
                                <p>Sports Management Worldwide is the global leader in sports business education.&nbsp;</p>

                                <h2>Sports Management Worldwide, Inc.</h2>

                                <p>SMWW Headquarters:<br />
                                500 Ala Moana Building 7, Suite 400<br />
                                Honolulu, Hawaii 96813<br />
                                <a href="tel:+1 503-445-7105">+1 503-445-7105</a><br />
                                Fax: +1&nbsp;503-445-9392</p>
                                <p>SMWW Fulfilment Center:</p>
                                <p>1100 NW Glisan Street, Suite 2B<br />
                                Portland, Oregon 97209<br />
                                <br />
                                Toll-Free: <a href="tel:877-769-9669">877-SMWW-Now</a> or&nbsp;<a href="tel:888-952-4368">1-888-95-Agent</a><br />
                                International: <a href="tel:+44(0) 871-288-4799">+44(0) 871-288-4799</a></p>
                                <div className="contact_us_buttons">
                                    <h3>
                                        <a className="form-submit scout-contact-email scout-site-contact-button" href="mailto:info@smww.com" target="_blank">
                                            Email Us for More Info
                                        </a>
                                    </h3>
                                    {domainName === configData.RSMWW_DOMAIN && 
                                    <h3>
                                        <a className="form-submit scout-contact-talk scout-site-contact-button" href={configData.DRUPAL_DOMAIN_URL+"/talk-with-dr-lynn-lashbrook"} rel="nofollow" target="_blank">
                                            Talk With Dr. Lynn Lashbrook
                                        </a>
                                    </h3>
                                    }
                                    {domainName === configData.RSMWW_AGENCY_DOMAIN && 
                                    <h3>
                                        <a className="form-submit scout-contact-talk scout-site-contact-button" href={configData.AGENCY_DOMAIN_URL+"/talk-with-dr-lynn-lashbrook"} rel="nofollow" target="_blank">
                                            Talk With Dr. Lynn Lashbrook
                                        </a>
                                    </h3>
                                    }
                                    {domainName === configData.RSMWW_SCOUT_DOMAIN &&
                                    <h3>
                                        <a className="form-submit scout-contact-talk scout-site-contact-button" href={configData.SCOUT_DOMAIN_URL+"/talk-with-dr-lynn-lashbrook"} rel="nofollow" target="_blank">
                                            Talk With Dr. Lynn Lashbrook
                                        </a>
                                    </h3>
                                    }
                                </div>
                                <div>&nbsp;</div>

                                <div><em>Sports Management Worldwide&nbsp;is&nbsp;a family of three companies, which includes:</em></div>
                                <div>&nbsp;</div>
                                
                                <ul>
                                    <li><a href="http://sportsmanagementworldwide.com">SportsManagementWorldwide.com</a></li>
                                    <li><a href="http://SMWWScout.com">SMWWScout.com</a></li>
                                    <li><a href="http://SMWWAgency.com">SMWWAgency.com</a></li>
                                </ul>

                                <p>&nbsp; &nbsp;</p>
                            </div>
                            <div className="right-content">
                                <div className="rteright">
                                    <iframe 
                                        align="right" 
                                        allowfullscreen="" 
                                        frameborder="0" 
                                        width="800" 
                                        height="435" 
                                        scrolling="no" 
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3717.2519379754754!2d-157.8622103!3d21.3010591!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c006e0950a6ee27%3A0x1ad605b8a6d5b063!2s500%20Ala%20Moana%20Blvd%20ste%207-400%2C%20Honolulu%2C%20HI%2096813!5e0!3m2!1sen!2sus!4v1764262943110!5m2!1sen!2sus" 
                                        style={{border:"0"}}
                                    ></iframe>
                                </div>
                            </div>
                            <div style={{clear: "both"}}>&nbsp;</div>
                        </div>
                    </div>
                    <div className="right"></div>
                </div>
            )}
        </div>
    );
};
export default ContactUs;